module.exports = __webpack_public_path__ + "static/media/check-fill.aa16fe3d.svg";